module.exports = __webpack_public_path__ + "static/img/thank-you.adc49538.gif";